var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.201,
    height: 19.201,
    viewBox: "0 0 19.201 19.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M10,.4A9.6,9.6,0,1,0,19.6,10,9.6,9.6,0,0,0,10,.4Zm.9,3.466A1.057,1.057,0,0,1,12.107,5.03a1.544,1.544,0,0,1-1.679,1.492c-.886,0-1.308-.445-1.282-1.182A1.584,1.584,0,0,1,10.9,3.866ZM8.5,15.75c-.64,0-1.107-.389-.66-2.094l.733-3.025c.127-.484.148-.678,0-.678a4.863,4.863,0,0,0-1.512.664l-.319-.523a8.506,8.506,0,0,1,4.108-2.061c.64,0,.746.756.427,1.92l-.84,3.18c-.149.562-.085.756.064.756a3.3,3.3,0,0,0,1.438-.719l.362.486A6.683,6.683,0,0,1,8.5,15.75Z",
    transform: "translate(-0.399 -0.4)",
    fill: "#2D3040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9e565c03fe51e684a461c9097d2d8678.svg";
export { ForwardRef as ReactComponent };